export const HeaderTheme = {
  transparent: 'transparent',
  white: 'white',
  blue: 'blue',
} as const;

export const HeaderSize = {
  default: 'default',
  full: 'full',
} as const;

export const HeaderZindex = {
  default: 100,
  hover: 20001,
};

export type HeaderThemeType = keyof typeof HeaderTheme;
export type HeaderSizeType = keyof typeof HeaderSize;

export type HeaderThemeMessage = {
  type: 'MRT_HEADER_CHANGES';
  value: {
    theme: HeaderThemeType;
    size: HeaderSizeType;
    disabled?: boolean;
    excludeLnb?: boolean;
  };
};

export const BenefitPageUrl = '/promotions/benefit';
